module.exports = __webpack_public_path__ + "img/truebill.bc6f3041.webp";